import { Component, OnInit } from '@angular/core';
import { IvaPagClieService, PageBusquedaObject } from './iva-pag-clie.service';
import { LoginService } from '../../../login/login.service';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-iva-pag-clie',
  templateUrl: './iva-pag-clie.component.html',
  styleUrls: ['./iva-pag-clie.component.css'],
  providers: [IvaPagClieService]
})
export class IvaPagClieComponent implements OnInit {
  cuenta_contable_txt: String = '';
  cuenta_contable_txt_nombre: String = '';
  cuenta_contable_id: number = 0;
  ctb_tpol_grupo_id: number = 1;
  fecha_inicial: String = '';
  fecha_final: String = '';
  gral_emp_id: number = 16;
  reporte: [] = [];
  tpolGrupos: any[] = [{}];
  busquedaCuentasPadres: PageBusquedaObject = new PageBusquedaObject();
  lista_cuentas: any[] = [];
  ctb_erp_rep_iva_pagado_clie_pa_json: any = {};
  lista_temporal: any[] = [];
  constructor(private ivaPagClieService: IvaPagClieService, private loginService: LoginService) {
    this.gral_emp_id = this.loginService.usuario.empresa_seleccionada.id;

  }

  ngOnInit(): void {
    this.getInicioYFinMes();
    this.cargarGrupos();
  }

  // Setear las fechas iniciales y finales respecto al mes actual detectado
  getInicioYFinMes() {
    const fechaActual = new Date();
    const primerDiaMes = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);
    const ultimoDiaMes = new Date(fechaActual.getFullYear(), fechaActual.getMonth() + 1, 0);
    this.fecha_inicial = this.formatoFecha(primerDiaMes);
    this.fecha_final = this.formatoFecha(ultimoDiaMes);

  }

  // Función para formatear la fecha en formato YYYY-MM-DD requerido por el api 
  formatoFecha(fecha: Date): string {
    const año = fecha.getFullYear();
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const dia = fecha.getDate().toString().padStart(2, '0');
    return `${año}-${mes}-${dia}`;
  }
  //Metodo para hacer la petición al API del reporte
  cargarReporteIvaPagado() {
    this.mostrarMensajeCarga();
    this.ivaPagClieService.getRepIvaPag(this.gral_emp_id, this.ctb_tpol_grupo_id, this.cuenta_contable_id, this.fecha_inicial, this.fecha_final).subscribe(
      response => {
        this.reporte = response.contenido;
        this.cerrarMensajeCarga();
      }
    );
  }

  ctb_erp_rep_iva_pagado_clie_pa() {
    this.mostrarMensajeCarga();
    this.ivaPagClieService.ctb_erp_rep_iva_pagado_clie_pa(this.gral_emp_id, this.cuenta_contable_id, this.fecha_inicial, this.fecha_final).subscribe(
      response => {
        this.cerrarMensajeCarga();
        this.ctb_erp_rep_iva_pagado_clie_pa_json = JSON.parse(response.contenido);
      }
    );
  }
  ctb_erp_rep_iva_pagado_clie_paExportAsXLSX(){
    let data1 = this.ctb_erp_rep_iva_pagado_clie_pa_json.iva_pagado;
    let data2 = this.ctb_erp_rep_iva_pagado_clie_pa_json.iva_pagado_agrupado_fecha_pago;
    let data3 = this.ctb_erp_rep_iva_pagado_clie_pa_json.comp_iva_pagado_fecha_poliza;
    let data4 = this.ctb_erp_rep_iva_pagado_clie_pa_json.auxiliar;
    // Crear un nuevo libro de Excel
    const workbook = XLSX.utils.book_new();

    // Datos para la primera pestaña
    const sheetData1 = [
      [
        "Folio de póliza",
        "Tipo de Póliza",
        "Concepto de póliza",
        "IVA causado póliza",
        "Referencia de pago",
        "No. Factura",
        "RFC del cliente",
        "Razón social",
        "Fecha de pago",
        "Método de pago",
        "Base sin impuesto",
        "Tipo de cambio del pago",
        "Importe base que paga IVA trasladado 16%",
        "IVA trasladado 16%",
        "Importe base que paga IVA retenido 16%",
        "IVA retenido 16%",
        "Importe base que paga IVA trasladado 8%",
        "IVA trasladado 8%",
        "Importe base que paga IVA retenido 8%",
        "IVA retenido 8%",
        "Importe base que paga IVA 0%",
        "Importe cobrado tasa exenta",
        "IVA cuota trasladada",
        "IVA cuota retenida",
        "Total IVA trasladado",
        "Total IVA retenido",
        "Estatus"
      ],
      ...data1.map(item => [
        item.folio_poliza,
        item.titulo,
        item.concepto_poliza,
        item.iva_causado_poliza,
        item.referencia_pago,
        item.no_fac,
        item.rfc_cliente,
        item.razon_social,
        item.fecha_pago,
        item.metodo_pago,
        item.base_sin_impuesto,
        item.tipo_cambio_pago,
        item.importe_base_que_paga_iva_trasladado_16_porciento,
        item.iva_trasladado_16_porciento,
        item.importe_base_que_paga_iva_retenido_16_porciento,
        item.iva_retenido_16_porciento,
        item.importe_base_que_paga_iva_trasladado_8_porciento,
        item.iva_trasladado_8_porciento,
        item.importe_base_que_paga_iva_retenido_8_porciento,
        item.iva_retenido_8_porciento,
        item.importe_base_que_paga_iva_0_porciento,
        item.importe_cobrado_tasa_exenta,
        item.iva_cuota_trasladada,
        item.iva_cuota_retenida,
        item.total_iva_trasladado,
        item.total_iva_retenido,
        item.estatus
      ])
    ];

    // Datos para la segunda pestaña
    const sheetData2 = [
      [
        "Folio de póliza",
        "Tipo de Póliza",
        "Concepto de póliza",
        "IVA causado póliza",
        "Referencia de pago",
        "No. Factura",
        "RFC del cliente",
        "Razón social",
        "Fecha de pago",
        "Método de pago",
        "Base sin impuesto",
        "Importe base que paga IVA trasladado 16%",
        "IVA trasladado 16%",
        "Importe base que paga IVA retenido 16%",
        "IVA retenido 16%",
        "Importe base que paga IVA trasladado 8%",
        "IVA trasladado 8%",
        "Importe base que paga IVA retenido 8%",
        "IVA retenido 8%",
        "Importe base que paga IVA 0%",
        "Importe cobrado tasa exenta",
        "IVA cuota trasladada",
        "IVA cuota retenida",
        "Total IVA trasladado",
        "Total IVA retenido",
        "Estatus"
      ],
      ...data2.map(item => [
        item.folio_poliza,
        item.titulo,
        item.concepto_poliza,
        item.iva_causado_poliza,
        item.referencia_pago,
        item.no_fac,
        item.rfc_cliente,
        item.razon_social,
        item.fecha_pago,
        item.metodo_pago,
        item.base_sin_impuesto,
        item.importe_base_que_paga_iva_trasladado_16_porciento,
        item.iva_trasladado_16_porciento,
        item.importe_base_que_paga_iva_retenido_16_porciento,
        item.iva_retenido_16_porciento,
        item.importe_base_que_paga_iva_trasladado_8_porciento,
        item.iva_trasladado_8_porciento,
        item.importe_base_que_paga_iva_retenido_8_porciento,
        item.iva_retenido_8_porciento,
        item.importe_base_que_paga_iva_0_porciento,
        item.importe_cobrado_tasa_exenta,
        item.iva_cuota_trasladada,
        item.iva_cuota_retenida,
        item.total_iva_trasladado,
        item.total_iva_retenido,
        item.estatus
      ])
    ];
// Datos para la tercera pestaña
const sheetData3 = [
  [
    "Folio de Póliza",
    "Concepto de Póliza",
    "IVA Causado en Póliza",
    "Total IVA Factura",
    "Diferencia Póliza-Pago"
  ],
  ...data3.map(item => [
    item.folio_poliza,
    item.concepto_poliza,
    item.iva_causado_poliza,
    item.total_facturas_iva,
    item.diferencia_poliza_pago
  ])
];

// Datos para la cuarta pestaña
const sheetData4 = [
  [
    "Folio de Póliza",
    "Tipo de Póliza",
    "Concepto de Póliza",
    "Cuenta Analizada",
    "Concepto Movimiento",
    "Cargo Asiento Contable",
    "Abono Asiento Contable",
    "Factura que Abona el Pago",
    "Fecha de Pago",
    "Total IVA Trasladado en Pago",
    "Total IVA Retenido en Pago",
    "Estatus"
  ],
  ...data4.map(item => [
    item.folio_poliza,
    item.titulo,
    item.concepto_poliza,
    item.cuenta,
    item.concepto,
    item.cargo_asiento_contable,
    item.abono_asiento_contable,
    item.factura_asociada,
    item.fecha_pago,
    item.total_iva_trasladado_pago,
    item.total_iva_retenido_pago,
    item.estatus
  ])
];
    // Convertir los datos en hojas de cálculo
    const ws1: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(sheetData1);
    const ws2: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(sheetData2);
    const ws3: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(sheetData3);
    const ws4: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(sheetData4);

    // Agregar las hojas al libro de Excel
    XLSX.utils.book_append_sheet(workbook, ws1, 'IVA PAGADO');
    XLSX.utils.book_append_sheet(workbook, ws2, 'IVA PAGADO AGRUPADO FECHA PAGO');
    XLSX.utils.book_append_sheet(workbook, ws3, 'Comp IVA Póliza VS Factura');
    XLSX.utils.book_append_sheet(workbook, ws4, 'AUXILIAR');



       // Establecer el ancho de las columnas manualmente en el orden del JSON
       ws1['!cols'] = [
        { width: 20 }, 
        { width: 30 },
        { width: 50 },
        { width: 30 }, 
        { width: 30 }, 
        { width: 30 }, 
        { width: 20 },  
        { width: 30 },  
        { width: 30 }, 
        { width: 30 }, 
        { width: 30 }, 
        { width: 30 }, 
        { width: 30 },
        { width: 30 },  
        { width: 30 }, 
        { width: 30 },
        { width: 30 },
        { width: 30 }, 
        { width: 30 }, 
        { width: 30 }, 
        { width: 30 }, 
        { width: 30 }, 
        { width: 30 }, 
        { width: 30 }, 
        
        { width: 30 },
        { width: 30 }, 
        { width: 30 }  
      ];
  
  
    // Aplicar estilo en negrita a los títulos de las columnas
    let headerStyle = { font: { bold: true } };
    let headerRange = XLSX.utils.decode_range(ws1['!ref']);
    for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
      const headerCell = XLSX.utils.encode_cell({ r: headerRange.s.r, c: col });
      ws1[headerCell].s = headerStyle;
    }


        // Establecer el ancho de las columnas manualmente en el orden del JSON
        ws2['!cols'] = [
          { width: 20 }, 
          { width: 30 },
          { width: 50 },
          { width: 30 }, 
          { width: 30 }, 
          { width: 30 }, 
          { width: 20 },  
          { width: 30 },  
          { width: 30 }, 
          { width: 30 }, 
          { width: 30 }, 
          { width: 30 }, 
          { width: 30 },
          { width: 30 },  
          { width: 30 }, 
          { width: 30 },
          { width: 30 },
          { width: 30 }, 
          { width: 30 }, 
          { width: 30 }, 
          { width: 30 }, 
          { width: 30 }, 
          { width: 30 }, 
          { width: 30 }, 
          
          { width: 30 },
          { width: 30 }
        ];
    
    
      // Aplicar estilo en negrita a los títulos de las columnas
       headerStyle = { font: { bold: true } };
       headerRange = XLSX.utils.decode_range(ws2['!ref']);
      for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
        const headerCell = XLSX.utils.encode_cell({ r: headerRange.s.r, c: col });
        ws2[headerCell].s = headerStyle;
      }
      // Establecer el ancho de las columnas manualmente en el orden del JSON
      ws3['!cols'] = [
        { width: 20 }, 
        { width: 50 },
        { width: 20 },
        { width: 30 }, 
        { width: 30 }, 
        { width: 30 }, 
        { width: 20 }
      ];
  
  
    // Aplicar estilo en negrita a los títulos de las columnas
     headerStyle = { font: { bold: true } };
     headerRange = XLSX.utils.decode_range(ws3['!ref']);
    for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
      const headerCell = XLSX.utils.encode_cell({ r: headerRange.s.r, c: col });
      ws3[headerCell].s = headerStyle;
    }
      // Establecer el ancho de las columnas manualmente en el orden del JSON
      ws4['!cols'] = [
        { width: 20 }, 
        { width: 30 },
        { width: 50 },
        { width: 30 }, 
        { width: 30 }, 
        { width: 30 }, 
        { width: 20 },  
        { width: 30 },  
        { width: 30 }, 
        { width: 30 }, 
        { width: 30 }, 
        { width: 30 }, 
        { width: 30 }
      ];
  
  
    // Aplicar estilo en negrita a los títulos de las columnas
     headerStyle = { font: { bold: true } };
     headerRange = XLSX.utils.decode_range(ws4['!ref']);
    for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
      const headerCell = XLSX.utils.encode_cell({ r: headerRange.s.r, c: col });
      ws4[headerCell].s = headerStyle;
    }
    // Guardar el archivo Excel
    XLSX.writeFile(workbook,this.loginService.usuario.empresa_seleccionada.titulo.toLowerCase().replace(/\s+/g, '_') + '_iva_cobrado_a_clientes_' + this.fecha_inicial + '_a_' + this.fecha_final + '.xlsx');
  }

  //Cargar los grupos de póliza
  cargarGrupos() {
    this.ivaPagClieService.tpolGetGrupo().subscribe(response => {
      this.tpolGrupos = response;
      {
        this.ctb_tpol_grupo_id = this.tpolGrupos[0].id;
      }
      this.cargarReporteIvaPagado();
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
    });
  }
  asignarCuenta(campo: String) {
    this.busquedaCuentasPadres = new PageBusquedaObject();
    this.busquedaCuentasPadres.criteriaSearch = {};
    if (campo == 'cuenta') {
      this.busquedaCuentasPadres.criteriaSearch['cuenta'] = this.cuenta_contable_txt;
      this.busquedaCuentasPadres.criteriaSearch['nombre'] = '';
    } else {
      this.busquedaCuentasPadres.criteriaSearch['nombre'] = this.cuenta_contable_txt_nombre;
      this.busquedaCuentasPadres.criteriaSearch['cuenta'] = '';
    }
    this.busquedaCuentasPadres.itemsPerPage = 5;
    this.busquedaCuentasPadres.pageNumber = 0;
    this.busquedaCuentasPadres.criteriaSearch['suc'] = this.loginService.sucursal;
    this.busquedaCuentasPadres.criteriaSearch['emp'] = this.loginService.empresa;
    this.ivaPagClieService.ctaCatalogo(this.busquedaCuentasPadres).subscribe(response => {
      this.lista_cuentas = response.contenido.content;
      if (campo == 'cuenta') {
      if (this.busquedaCuentasPadres.criteriaSearch['cuenta'] === this.lista_cuentas[0].cuenta) {
        this.cuenta_contable_id = this.lista_cuentas[0].id;
        this.cuenta_contable_txt = this.lista_cuentas[0].cuenta;
        this.cuenta_contable_txt_nombre = this.lista_cuentas[0].nombre;
        this.lista_cuentas = [];
      }
    } else {
      if (this.busquedaCuentasPadres.criteriaSearch['nombre'] === this.lista_cuentas[0].nombre) {
        this.cuenta_contable_id = this.lista_cuentas[0].id;
        this.cuenta_contable_txt = this.lista_cuentas[0].cuenta;
        this.cuenta_contable_txt_nombre = this.lista_cuentas[0].nombre;
        this.lista_cuentas = [];
      }
      }
      
    },
      err => {
        if (err.error.mensaje == null) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'Mensaje',
          text: err.error.mensaje
        })
        console.log(err);
      });
  }
  exportAsXLSX() {

    // Crear hoja de cálculo
    const wb = XLSX.utils.book_new(); // Crea un nuevo libro de Excel
    const dataRows = this.convertirJSONaArreglo(this.reporte);
    const ws = XLSX.utils.aoa_to_sheet(dataRows);
    XLSX.utils.book_append_sheet(wb, ws, 'Hoja1'); // Agrega la hoja de cálculo al libro

    // Establecer el ancho de las columnas manualmente en el orden del JSON
    ws['!cols'] = [
      { width: 20 },  // folio_poliza
      { width: 30 },  // titulo
      { width: 50 },  // concepto_poliza
      { width: 15 },  // fecha_poliza
      { width: 30 },  // iva_causado_poliza
      { width: 15 },  // serie_folio
      { width: 20 },  // rfc
      { width: 30 },  // cliente
      { width: 15 },  // fecha_cfdi
      { width: 15 },  // metodo_pago
      { width: 30 },  // monto_total_pagos
      { width: 30 },  // total_traslados_base_iva16
      { width: 30 },  // total_traslados_impuesto_iva16
      { width: 30 },  // total_traslados_base_iva8
      { width: 30 },  // total_traslados_impuesto_iva8
      { width: 30 },  // total_traslados_base_iva0
      { width: 30 },  // total_traslados_impuesto_iva0
      { width: 30 }  // total_traslados_base_iva_exento
    ];

  // Aplicar filtros a la hoja de cálculo
  ws['!autofilter'] = { ref: XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: 0, c: dataRows[0].length - 1 } }) };

  // Aplicar estilo en negrita a los títulos de las columnas
  const headerStyle = { font: { bold: true } };
  const headerRange = XLSX.utils.decode_range(ws['!ref']);
  for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
    const headerCell = XLSX.utils.encode_cell({ r: headerRange.s.r, c: col });
    ws[headerCell].s = headerStyle;
  }


    XLSX.writeFile(wb, this.loginService.empresa_info_actual.titulo.toLowerCase().replace(/\s+/g, '_') + '_iva_cobrado_a_clientes_' + this.fecha_inicial + '_a_' + this.fecha_final + '.xlsx'); // Descarga el archivo Excel con el nombre proporcionado
  }

  convertirJSONaArreglo(jsonData: any[]): any[][] {
    const headerRow = [
      'Folio Póliza',
      'Titulo Póliza',
      'Concepto Póliza',
      'Fecha Póliza',
      'TOTAL: ' + this.cuenta_contable_txt_nombre,
      'Serie y Folio',
      'Rfc Cliente',
      'Nombre Cliente',
      'Fecha CFDI',
      'Metodo Pago',
      'Monto Total Pagos',
      'Total Traslados Base IVA16',
      'Total Traslados Impuesto IVA16',
      'total Traslados Base IVA8',
      'total Traslados Impuesto IVA8',
      'total Traslados Base IVA0',
      'total Traslados Impuesto IVA0',
      'total Traslados Base IVA EXENTO'
    ];

    const dataRows = jsonData.map(item => [
      item.folio_poliza,
      item.titulo,
      item.concepto_poliza,
      item.fecha_poliza,
      item.iva_causado_poliza,
      item.serie_folio,
      item.rfc,
      item.cliente,
      item.fecha_cfdi,
      item.metodo_pago,
      item.monto_total_pagos,
      item.total_traslados_base_iva16,
      item.total_traslados_impuesto_iva16,
      item.total_traslados_base_iva8,
      item.total_traslados_impuesto_iva8,
      item.total_traslados_base_iva0,
      item.total_traslados_impuesto_iva0,
      item.total_traslados_base_iva_exento
    ]);

    return [headerRow, ...dataRows];
  }
  mostrarMensajeCarga() {
    Swal.fire({
      title: 'Mensaje',
      html: 'Cargando Reporte...',
      timerProgressBar: true,
      showConfirmButton: false,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      }
    });
  }
  cerrarMensajeCarga() {
    Swal.close();
  }
}
